import React, { useContext } from "react";
import { Switch, Route } from "react-router";
import {
  loginUrl,
  financingRequestsUrl,
  financingRequestNewUrl,
  financingRequestEditUrl,
  financingRequestDetailsUrl,
  financingRequestPrintUrl,
  paymentRequestsUrl,
  paymentRequestNewUrl,
  paymentRequestEditUrl,
  paymentRequestDetailsUrl,
  paymentRequestPrintUrl,
  adminAnnualAdministrationsUrl,
  adminFinancingRequestsUrl,
  adminFinancingRequestDetailsUrl,
  adminPaymentRequestsUrl,
  adminPaymentRequestDetailsUrl,
  adminPaymentsUrl,
  financingRequestValidityRangeEditUrl
} from "./urls";
import UserContext from "./UserContext";
import LoginPage from "./components/login/LoginPage";
import FinancingRequestListPage from "./components/financing-request/FinancingRequestListPage";
import FinancingRequestPage from "./components/financing-request/FinancingRequestPage";
import FinancingRequestDetailsPage from "./components/financing-request/FinancingRequestDetailsPage";
import PaymentRequestListPage from "./components/payment-request/PaymentRequestListPage";
import PaymentRequestPage from "./components/payment-request/PaymentRequestPage";
import PaymentRequestDetailsPage from "./components/payment-request/PaymentRequestDetailsPage";
import AnnualAdministrationPage from "./components/admin/annual-administration/AnnualAdministrationPage";
import AdminFinancingRequestListPage from "./components/admin/financing-request/FinancingRequestListPage";
import AdminFinancingRequestDetailsPage from "./components/admin/financing-request/FinancingRequestDetailsPage";
import AdminPaymentRequestListPage from "./components/admin/payment-request/PaymentRequestListPage";
import AdminPaymentRequestDetailsPage from "./components/admin/payment-request/PaymentRequestDetailsPage";
import AdminPaymentListPage from "./components/admin/payment/PaymentListPage";
import UserRole from "./models/user/UserRole";
import FinancingRequestValidityRangeDataPage from "./components/financing-request/validity-range/FinancingRequestValidityRangeDataPage";

export default function Routing() {
  const { user } = useContext(UserContext);

  return (
    <Switch>
      <Route exact path={loginUrl()} component={LoginPage} />
      {user.roleId === UserRole.Ministry ? (
        <>
          <Route
            exact
            path={["/", adminAnnualAdministrationsUrl()]}
            component={AnnualAdministrationPage}
          />
          <Route
            exact
            path={adminFinancingRequestsUrl()}
            component={AdminFinancingRequestListPage}
          />
          <Route
            exact
            path={adminFinancingRequestDetailsUrl()}
            component={AdminFinancingRequestDetailsPage}
          />
          <Route
            exact
            path={adminPaymentRequestsUrl()}
            component={AdminPaymentRequestListPage}
          />
          <Route
            exact
            path={adminPaymentRequestDetailsUrl()}
            component={AdminPaymentRequestDetailsPage}
          />
          <Route
            exact
            path={adminPaymentsUrl()}
            component={AdminPaymentListPage}
          />
        </>
      ) : (
        <>
          <Route
            exact
            path={["/", financingRequestsUrl()]}
            component={FinancingRequestListPage}
          />
          <Route
            exact
            path={financingRequestNewUrl()}
            component={FinancingRequestPage}
          />
          <Route
            exact
            path={financingRequestEditUrl()}
            component={FinancingRequestPage}
          />
          <Route
            exact
            path={financingRequestDetailsUrl()}
            component={FinancingRequestDetailsPage}
          />
          <Route
            exact
            path={financingRequestPrintUrl()}
            component={FinancingRequestDetailsPage}
          />
          <Route
            exact
            path={financingRequestValidityRangeEditUrl()}
            component={FinancingRequestValidityRangeDataPage}
          />
          <Route
            exact
            path={paymentRequestsUrl()}
            component={PaymentRequestListPage}
          />
          <Route
            exact
            path={paymentRequestNewUrl()}
            component={PaymentRequestPage}
          />
          <Route
            exact
            path={paymentRequestEditUrl()}
            component={PaymentRequestPage}
          />
          <Route
            exact
            path={paymentRequestDetailsUrl()}
            component={PaymentRequestDetailsPage}
          />
          <Route
            exact
            path={paymentRequestPrintUrl()}
            component={PaymentRequestDetailsPage}
          />
        </>
      )}
    </Switch>
  );
}
